// extracted by mini-css-extract-plugin
export default {"productCarousel":"r0-z"};